import { useState } from 'react';
import { ts } from '../api';
import { Page, Section, Stat, Select, Table, Td, Loading, ErrorNote, useLoad, money } from '../ui';

export default function TSAnalytics() {
  const [days, setDays] = useState(30);
  const { data, loading, error } = useLoad(() => ts.analytics(days), [days]);
  if (loading && !data) return <Loading />;
  if (error) return <ErrorNote error={error} />;
  const answerRate = data.calls.inbound ? Math.round(((data.calls.inbound - data.calls.missed) / data.calls.inbound) * 100) : 0;
  return (
    <Page title="Analytics" actions={<Select value={days} onChange={(v) => setDays(Number(v))} options={[[7, 'Last 7 days'], [30, 'Last 30 days'], [90, 'Last 90 days']]} />}>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3" data-testid="ts-analytics">
        <Stat label="Calls" value={data.calls.total} hint={`${data.calls.inbound} in · ${data.calls.outbound} out`} />
        <Stat label="Inbound answered" value={`${answerRate}%`} hint={`${data.calls.missed} missed`} />
        <Stat label="Average call" value={`${data.calls.avg_duration_seconds}s`} />
        {data.advanced && <Stat label="AI front desk calls" value={data.ai.front_desk_calls} />}
        <Stat label="New leads" value={data.leads.new} />
        <Stat label="Qualified" value={data.leads.qualified} />
        <Stat label="Appointments" value={data.leads.appointments} />
        <Stat label="Won" value={data.leads.won} />
        <Stat label="Callback completion" value={`${data.callbacks.completion_rate}%`} hint={`${data.callbacks.overdue} overdue`} />
        <Stat label="Texts" value={data.sms.sent + data.sms.received} hint={`${data.sms.sent} sent · ${data.sms.received} received`} />
        {data.advanced && <Stat label="AI actions run" value={data.ai.actions_executed} />}
        {data.advanced && <Stat label="Usage over plan (this cycle)" value={money(data.telecom_cost_estimate_cents)} />}
      </div>
      {data.advanced ? (
        <Section title="By employee">
          <Table head={['Employee', 'Calls', 'Outbound', 'Connected', 'Missed', 'Talk min', 'Callbacks done']}>
            {data.staff.map(s => <tr key={s.member_id}><Td className="font-medium">{s.name}</Td><Td>{s.calls}</Td><Td>{s.outbound}</Td><Td>{s.connected}</Td><Td>{s.missed}</Td><Td>{s.talk_minutes}</Td><Td>{s.callbacks_done}</Td></tr>)}
          </Table>
        </Section>
      ) : (
        <p className="text-xs text-muted-foreground" data-testid="ts-analytics-upgrade">Per-employee, AI and cost breakdowns are part of the Business plan. Upgrade in Billing to see them.</p>
      )}
      <Section title="This cycle's usage">
        <div className="text-sm grid grid-cols-2 md:grid-cols-4 gap-2">
          <div>Minutes: <strong>{data.usage.minutes_used}</strong> of {data.usage.minutes_included}</div>
          <div>Text segments: <strong>{data.usage.sms_used}</strong> of {data.usage.sms_included}</div>
          <div>Extra minutes: {data.usage.minutes_over}</div>
          <div>Extra segments: {data.usage.sms_over}</div>
        </div>
      </Section>
    </Page>
  );
}
